<template>
  <div class="addictedGames">
    <!-- 你的孩子沉迷游戏吗 图片 -->
    <!-- <van-image
    class="addictedGames-img"
    width="205"
    height="50"
    fit="cover"
    :src="require('@/assets/pc-box-2-title.png')" /> -->
    <!-- 打游戏的图片 -->
    <van-image
    width="100%"
    fit="cover"
    :src="require('@/assets/m-img-2.png')" />
    <!-- 沉迷游戏危害信息 -->
    <van-cell size="large">
      <img slot="icon" src="@/assets/pc-box-2-icon-1.png" alt="">
      <h4 slot="title">影响学习</h4>
      <div slot="label">
        <p>
          学生缺少自制力，沉迷游戏花费大量时间，精力被分散导致学习成绩下滑
        </p>
        <P>
          上课走神打瞌睡，课堂要点记不住，学习进度难跟上
        </P>
      </div>
    </van-cell>
    <van-cell size="large">
          <img slot="icon" src="@/assets/pc-box-2-icon-2.png" alt="">
          <h4 slot="title">树立错误价值观</h4>
          <div slot="label">
            <p>
              早熟早恋：游戏中充斥各种情爱故事以及各种裸露性暗示内容防不胜防
            </p>
            <P>
              暴力厌学：游戏中的各种暴力元素容易影响孩子，变得脾气变得暴躁，说不得骂不得
            </P>
            <p>
              偷钱抢钱：游戏内各种充值变强的机制，容易诱导孩子偷钱充值等错误行为
            </p>
          </div>
    </van-cell>
    <van-cell size="large">
          <img slot="icon" src="@/assets/pc-box-2-icon-3.png" alt="">
          <h4 slot="title">影响身体健康成长</h4>
          <div slot="label">
            <p>
              孩子视网膜暂未发育成熟，长期使用手机容易导致近视
            </p>
            <P>
              严重缩减户外活动时间导致全面身体素质下降
            </P>
            <p>
              低头玩手机颈椎压迫，可能导致驼背，大脑供血不足
            </p>
          </div>
    </van-cell>

  </div>
</template>

<script>
export default {
  name: 'addictedGames'
}
</script>

<style scoped>
*{
  margin: 0;
  padding: 0;
}
.addictedGames{
  padding: 60px 15px 35px;
}
.van-image:nth-child(1){
  display: block;
  margin: 0 auto;
}
.van-image:nth-child(2){
  margin-top: 10px;
}
img{
  width: 16px;
  height: 16px;
  margin-right: 6px;
}
h4{
  font-size: 14px;
  font-weight: 400;
}
p{
  font-size: 12px;
  color: #909090;
}
.van-cell{
  padding: 12px 0;
}
</style>
